
export default {

  images: {
    //
    // CONSERVATORI CP
    //
    "CP Multi Steel single door": {
      "dashboard": "/cp/CP porta singola acciaio.png",
      "details": "/cp/CP NEXT porta intera acciaio.png",
      "report": "CK porta singola.png"
    },
    "CP Multi Glass single door": {
      "dashboard": "/cp/CP porta singola vetro.png",
      "details": "/cp/CP NEXT porta intera vetro.png",
      "report": "CP doppia porta vetro.png"
    },
    "CP Multi Steel double door": {
      "dashboard": "/cp/CP porta doppia acciaio.png",
      "details": "/cp/CP NEXT doppia porta acciaio.png",
      "report": "CP doppia porta acciaio.png"
    },
    "CP Multi Glass double door": {
      "dashboard": "/cp/CP porta doppia vetro.png",
      "details": "/cp/CP NEXT doppia porta vetro.png",
      "report": "CP doppia porta vetro.png"
    },
    "CP Up Steel single door": {
      "dashboard": "/cp/CP porta singola acciaio.png",
      "details": "/cp/CP NEXT porta intera acciaio.png",
      "report": "CK porta singola.png"
    },
    "CP Up Steel double door": {
      "dashboard": "/cp/CP porta doppia acciaio.png",
      "details": "/cp/CP NEXT doppia porta acciaio.png",
      "report": "CP doppia porta acciaio.png"
    },
    "CP Up Glass single door": {
      "dashboard": "/cp/CP porta singola vetro.png",
      "details": "/cp/CP NEXT porta intera vetro.png",
      "report": "CP doppia porta vetro.png"
    },
    "CP Up Glass double door": {
      "dashboard": "/cp/CP porta doppia vetro.png",
      "details": "/cp/CP NEXT doppia porta vetro.png",
      "report": "CP doppia porta vetro.png"
    },
    "CP Next Mini Steel single door": {
      "dashboard": "/cp/CP mini.png",
      "details": "/cp/CP mini.png",
      "report": "CK porta singola.png"
    },
    "CP Next Mini Glass single door": {
      "dashboard": "/cp/CP mini.png",
      "details": "/cp/CP mini.png",
      "report": "CP doppia porta vetro.png"
    },
    //
    // CONSERVATORI CK
    //
    "CK Multi Steel single door": {
      "dashboard": "/ck/CK porta singola acciaio.png",
      "details": "/ck/CK NEXT porta acciaio.png",
      "report": "CK porta singola.png"
    },
    "CK Multi Steel double door": {
      "dashboard": "/ck/CK porta singola acciaio.png",
      "details": "/ck/CK NEXT porta acciaio.png",
      "report": "CK porta singola.png"
    },
    "CK Multi Glass single door": {
      "dashboard": "/ck/CK porta vetro.png",
      "details": "/ck/CK NEXT porta vetro.png",
      "report": "CP doppia porta vetro.png"
    },
    "CK Multi Glass double door": {
      "dashboard": "/ck/CK porta vetro.png",
      "details": "/ck/CK NEXT porta vetro.png",
      "report": "CP doppia porta vetro.png"
    },
    "CK Up Steel single door": {
      "dashboard": "/ck/CK porta singola acciaio.png",
      "details": "/ck/CK NEXT porta acciaio.png",
      "report": "CK porta singola.png"
    },
    "CK Up Steel double door": {
      "dashboard": "/ck/CK porta singola acciaio.png",
      "details": "/ck/CK NEXT porta acciaio.png",
      "report": "CK porta singola.png"
    },
    "CK Up Glass single door": {
      "dashboard": "/ck/CK porta vetro.png",
      "details": "/ck/CK NEXT porta vetro.png",
      "report": "CP doppia porta vetro.png"
    },
    "CK Up Glass double door": {
      "dashboard": "/ck/CK porta vetro.png",
      "details": "/ck/CK NEXT porta vetro.png",
      "report": "CP doppia porta vetro.png"
    },
    //
    // ABBATTITORI MF NEXT (10 inch)
    //
    "MF Next S 10 inch": {
      "dashboard": "/mf-next-10/MF Next S.png",
      "details": "/mf-next-10/MF NEXT S.png",
      "report": "MFN L.png"
    },
    "MF Next SL 10 inch": {
      "dashboard": "/mf-next-10/MF Next SL.png",
      "details": "/mf-next-10/MF NEXT SL.png",
      "report": "MFN L.png"
    },
    "MF Next M 10 inch": {
      "dashboard": "/mf-next-10/MF Next M.png",
      "details": "/mf-next-10/MF NEXT M.png",
      "report": "MFN L.png"
    },
    "MF Next ML 10 inch": {
      "dashboard": "/mf-next-10/MF Next ML.png",
      "details": "/mf-next-10/MF NEXT ML.png",
      "report": "MFN L.png"
    },
    "MF Next L 10 inch": {
      "dashboard": "/mf-next-10/MF Next L.png",
      "details": "/mf-next-10/MF NEXT L.png",
      "report": "MFN L.png"
    },
    "MF Next LL 10 inch": {
      "dashboard": "/mf-next-10/MF Next LL.png",
      "details": "/mf-next-10/MF NEXT LL.png",
      "report": "MFN L.png"
    },
    "MF Next XL 10 inch": {
      "dashboard": "/mf-next-10/MF Next XL.png",
      "details": "/mf-next-10/MF NEXT XL.png",
      "report": "MFN L.png"
    },
    "MF Next XXL 10 inch": {
      "dashboard": "/mf-next-10/MF Next XXL.png",
      "details": "/mf-next-10/MF NEXT XXL.png",
      "report": "MFN L.png"
    },
    //
    // ABBATTITORI MF NEXT (4.3 inch)
    //
    "MF Next S 4.3 inch": {
      "dashboard": "/mf-next-43/MF Next S.png",
      "details": "/mf-next-43/MF NEXT S.png",
      "report": "MFN L.png"
    },
    "MF Next SL 4.3 inch": {
      "dashboard": "/mf-next-43/MF Next SL.png",
      "details": "/mf-next-43/MF NEXT SL.png",
      "report": "MFN L.png"
    },
    "MF Next M 4.3 inch": {
      "dashboard": "/mf-next-43/MF Next M.png",
      "details": "/mf-next-43/MF NEXT M.png",
      "report": "MFN L.png"
    },
    "MF Next ML 4.3 inch": {
      "dashboard": "/mf-next-43/MF Next ML.png",
      "details": "/mf-next-43/MF NEXT ML.png",
      "report": "MFN L.png"
    },
    "MF Next L 4.3 inch": {
      "dashboard": "/mf-next-43/MF Next L.png",
      "details": "/mf-next-43/MF NEXT L.png",
      "report": "MFN L.png"
    },
    "MF Next LL 4.3 inch": {
      "dashboard": "/mf-next-43/MF Next LL.png",
      "details": "/mf-next-43/MF NEXT LL.png",
      "report": "MFN L.png"
    },
    "MF Next XL 4.3 inch": {
      "dashboard": "/mf-next-43/MF Next XL.png",
      "details": "/mf-next-43/MF NEXT XL.png",
      "report": "MFN L.png"
    },
    "MF Next XXL 4.3 inch": {
      "dashboard": "/mf-next-43/MF Next XXL.png",
      "details": "/mf-next-43/MF NEXT XXL.png",
      "report": "MFN L.png"
    },
    //
    // ABBATTITORI EF NEXT
    //
    "EF Next XS": {
      "dashboard": "/ef-next/EFNR290_XS.png",
      "details": "/ef-next/EFNR290_XS.png",
      "report": "MFN L.png"
    },
    "EF Next S": {
      "dashboard": "/ef-next/EFNR290_S.png",
      "details": "/ef-next/EFNR290_S.png",
      "report": "MFN L.png"
    },
    "EF Next SL": {
      "dashboard": "/ef-next/EFNR290_SL.png",
      "details": "/ef-next/EFNR290_SL.png",
      "report": "MFN L.png"
    },
    "EF Next M": {
      "dashboard": "/ef-next/EFNR290_M.png",
      "details": "/ef-next/EFNR290_M.png",
      "report": "MFN L.png"
    },
    "EF Next ML": {
      "dashboard": "/ef-next/EFNR290_ML.png",
      "details": "/ef-next/EFNR290_ML.png",
      "report": "MFN L.png"
    },
    "EF Next L": {
      "dashboard": "/ef-next/EFNR290_L.png",
      "details": "/ef-next/EFNR290_L.png",
      "report": "MFN L.png"
    },
    "EF Next LL": {
      "dashboard": "/ef-next/EFNR290_LL.png",
      "details": "/ef-next/EFNR290_LL.png",
      "report": "MFN L.png"
    },
    //
    // ABBATTITORI MYA UNDER 90
    //
    "MYA MF 25.1": {
      "dashboard": "/mya/MF90.1ST.jpg",
      "details": "/mya/MF90.1ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 30.2": {
      "dashboard": "/mya/MF90.1ST.jpg",
      "details": "/mya/MF90.1ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 45.1": {
      "dashboard": "/mya/MF90.1ST.jpg",
      "details": "/mya/MF90.1ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 45.1 L": {
      "dashboard": "/mya/MF90.1ST.jpg",
      "details": "/mya/MF90.1ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 70.1": {
      "dashboard": "/mya/MF90.1ST.jpg",
      "details": "/mya/MF90.1ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 70.1 L": {
      "dashboard": "/mya/MF90.1ST.jpg",
      "details": "/mya/MF90.1ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 70.2": {
      "dashboard": "/mya/MF90.1ST.jpg",
      "details": "/mya/MF90.1ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 85.2": {
      "dashboard": "/mya/MF90.1ST.jpg",
      "details": "/mya/MF90.1ST.jpg",
      "report": "MYA MF250.2.png"
    },
    //
    // ABBATTITORI MYA OVER 90
    //
    "MYA MF 90.1 ST": {
      "dashboard": "/mya/MF90.1ST.jpg",
      "details": "/mya/MF90.1ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 100.1 ST": {
      "dashboard": "/mya/MF100.1-ST.jpg",
      "details": "/mya/MF100.1-ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 100.1": {
      "dashboard": "/mya/MF100.1.jpg",
      "details": "/mya/MF100.1.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 100.2": {
      "dashboard": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "details": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 100.2 ST": {
      "dashboard": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "details": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 130.2": {
      "dashboard": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "details": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 130.2 ST": {
      "dashboard": "/mya/MF130.2_ST.jpg",
      "details": "/mya/MF130.2_ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 180.2": {
      "dashboard": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "details": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 180.2 ST": {
      "dashboard": "/mya/MF180.2-ST.jpg",
      "details": "/mya/MF180.2-ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 180.2 L": {
      "dashboard": "/mya/MF180.2-L.jpg",
      "details": "/mya/MF180.2-L.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 250.2": {
      "dashboard": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "details": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 250.2 2T": {
      "dashboard": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "details": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 350.2 2T": {
      "dashboard": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "details": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 350.2 2T L": {
      "dashboard": "/mya/MF350.2-2T-L.jpg",
      "details": "/mya/MF350.2-2T-L.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 350.2 3T": {
      "dashboard": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "details": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 500.2 2T": {
      "dashboard": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "details": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 500.2 3T": {
      "dashboard": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "details": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 500.2 3T L": {
      "dashboard": "/mya/MF500.2-3T-L.jpg",
      "details": "/mya/MF500.2-3T-L.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 750.2 3T": {
      "dashboard": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "details": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 750.2 4T": {
      "dashboard": "/mya/MF750.2-4T.jpg",
      "details": "/mya/MF750.2-4T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 750.2 4T L": {
      "dashboard": "/mya/MF750.2-4T-L.jpg",
      "details": "/mya/MF750.2-4T-L.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 1000.2 4T": {
      "dashboard": "/mya/MF750.2-4T.jpg",
      "details": "/mya/MF750.2-4T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 1000.2 4T L": {
      "dashboard": "/mya/MF750.2-4T-L.jpg",
      "details": "/mya/MF750.2-4T-L.jpg",
      "report": "MYA MF250.2.png"
    },
    //
    // ABBATTITORI MYA OVER 90 with CO2
    //
    "MYA MF 100.1 ST CO2": {
      "dashboard": "/mya/MF100.1-ST.jpg",
      "details": "/mya/MF100.1-ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 100.1 CO2": {
      "dashboard": "/mya/MF100.1.jpg",
      "details": "/mya/MF100.1.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 100.2 CO2": {
      "dashboard": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "details": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 100.2 ST CO2": {
      "dashboard": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "details": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 130.2 CO2": {
      "dashboard": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "details": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 130.2 ST CO2": {
      "dashboard": "/mya/MF130.2_ST.jpg",
      "details": "/mya/MF130.2_ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 180.2 CO2": {
      "dashboard": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "details": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 180.2 ST CO2": {
      "dashboard": "/mya/MF180.2-ST.jpg",
      "details": "/mya/MF180.2-ST.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 180.2 L CO2": {
      "dashboard": "/mya/MF180.2-L.jpg",
      "details": "/mya/MF180.2-L.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 250.2 CO2": {
      "dashboard": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "details": "/mya/MF100.2_MF130.2_MF180.2_MF250.2.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 250.2 2T CO2": {
      "dashboard": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "details": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 350.2 2T CO2": {
      "dashboard": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "details": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 350.2 2T L CO2": {
      "dashboard": "/mya/MF350.2-2T-L.jpg",
      "details": "/mya/MF350.2-2T-L.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 350.2 3T CO2": {
      "dashboard": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "details": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 500.2 2T CO2": {
      "dashboard": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "details": "/mya/MF250.2-2T_MF350.2-2T_MF500.2-2T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 500.2 3T CO2": {
      "dashboard": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "details": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 500.2 3T L CO2": {
      "dashboard": "/mya/MF500.2-3T-L.jpg",
      "details": "/mya/MF500.2-3T-L.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 750.2 3T CO2": {
      "dashboard": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "details": "/mya/MF350.2-3T_MF500.2-3T_MF750.2-3T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 750.2 4T CO2": {
      "dashboard": "/mya/MF750.2-4T.jpg",
      "details": "/mya/MF750.2-4T.jpg",
      "report": "MYA MF250.2.png"
    },
    "MYA MF 750.2 4T L CO2": {
      "dashboard": "/mya/MF750.2-4T-L.jpg",
      "details": "/mya/MF750.2-4T-L.jpg",
      "report": "MYA MF250.2.png"
    },
    //
    // FERMALIEVITA MP
    //
    "MP Next One Steel single door": {
      "dashboard": "/mp/MP porta intera acciaio.png",
      "details": "/mp/MP porta intera acciaio.png",
      "report": "MP NEXT.png"
    },
    //
    // SIMPLYFRESH
    //
    "SF 5T": {
      "dashboard": "/sf/sf.jpg",
      "details": "/sf/sf.jpg",
      "report": "MFN L.png"
    }
  },
  image(modelNumber, accessory, isDetails) {
    if(modelNumber == null) {
      return "assets/irinox/images/appliances/default.png";
    }
    let key = modelNumber;
    if(accessory && accessory.trim()!="") {
      key = modelNumber+" "+accessory;
    }
    // console.log("KEY: " + key);
    let img = this.images[key.trim()];
    let type = isDetails?"details":"dashboard";
    if(img) {
      return "assets/irinox/images/appliances/" + type + img[type];
    } else {
      return "assets/irinox/images/appliances/default.png";
    }
  },
  reportImage(modelName) {
    let img = this.images[modelName];
    return (img && img.report ? "assets/irinox/images/report/" + img.report : "assets/irinox/images/report/EFN L.png");
  }

}
